import React, { useContext, useEffect } from 'react';
import { useLocation } from '@reach/router';
import { GlobalContext } from '@src/store/global-state';
import Loader from '../loader/loader';
import { redirectToShopifyAuth } from '@src/utils/auth-redirect';

const PrivateRoute: React.FC<any> = ({ component: Component, path, ...rest }) => {
  const { isCheckLoginTried, isLoggedIn } = useContext(GlobalContext);
  const location = useLocation();

  useEffect(() => {
    if (isCheckLoginTried && !isLoggedIn) redirectToShopifyAuth(location.pathname);
  }, [isLoggedIn, isCheckLoginTried]);

  if (!isCheckLoginTried || !isLoggedIn) return <Loader />;

  return <Component {...rest} />;
};

export default PrivateRoute;
